<template>
    <b-badge
        :variant="variant"
        :href="href"
        :rel="relDefaults"
        :target="target"
        :active="active"
        :disabled="disabled"
        pill
    >
        <slot />
    </b-badge>
</template>

<script>
    /**
     * @group Feedback
     * A component to utilize a Kit Car tag.
     */
    export default {
        name: 'Tag',
        props: {
            /**
             * Denotes the target URL of the link for standard a links
             */
            href: {
                type: String,
                required: false,
                // &mdash;
                default: null,
            },
            /**
             * Sets the 'rel' attribute on the rendered link
             */
            rel: {
                type: String,
                required: false,
                // &mdash;
                default: '',
            },
            /**
             * Sets the 'target' attribute on the rendered link
             */
            target: {
                type: String,
                required: false,
                // `'_self'`
                default: '_self',
            },
            /**
             * When set to `true`, places the component in the active state with active styling
             */
            active: {
                type: Boolean,
                required: false,
            },
            /**
             * When set to `true`, disables the component's functionality and places it in a disabled state
             */
            disabled: {
                type: Boolean,
                required: false,
            },
            /**
             * Applies one of the Kit Car theme color variants to the component
             */
            variant: {
                // `success`
                type: String,
                required: false,
                // `success`
                default: 'success'
            },
        },
        computed: {
            relDefaults() {
                if (this.target === '_blank') {
                    return `${this.rel} noopener noreferrer`;
                }

                return this.rel;
            }
        }
    };
</script>
